import React from 'react';
import styled from 'styled-components';

import { Firebase } from '../firebase';

export const Login: React.FC = () => {
  const [sid, setSid] = React.useState('');
  const [name, setName] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const onSubmit = async () => {
    if (sid === '' || name === '') {
      window.alert('학번 및 이름을 입력해주세요.');
      return;
    }
    if (loading) return;

    setLoading(true);

    window.localStorage.setItem('sidForSignIn', sid);
    window.localStorage.setItem('nameForSignIn', name);

    await Firebase.signIn();

    setLoading(false);
  };

  return (
    <Container>
      <Content>
        <Heading>로그인</Heading>
        <Input
          value={sid}
          onChange={(e) => setSid(e.target.value)}
          required
          type="number"
          placeholder="학번"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onSubmit();
            }
          }}
        />
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          type="text"
          placeholder="이름"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onSubmit();
            }
          }}
        />

        <Submit onClick={onSubmit} disabled={loading}>
          {loading ? '로그인 중...' : '로그인'}
        </Submit>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;

  @media only screen and (min-width: 400px) {
    max-width: 400px;
    margin: 0 auto;
  }
`;

const Content = styled.div`
  padding: 20px;
`;

const Heading = styled.h1`
  font-weight: bold;
`;

const Input = styled.input`
  outline: none;
  width: 100%;

  box-sizing: border-box;
  border: 1px solid #e9e9e9;
  border-radius: 5px;
  margin-top: 12px;
  padding: 8px;

  transition: border ease-in-out 200ms;

  :focus {
    border: 1px solid #023978;
  }
`;

const Submit = styled.button`
  outline: none;
  width: 100%;

  box-sizing: border-box;
  border: 1px solid #e9e9e9;
  border-radius: 5px;
  margin-top: 12px;
  padding: 8px;

  color: white;
  background-color: #023978;
`;
